import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import { sidebarToggle } from "./../../utils/toggler.js";
import BottomNavbar from "../BottomNavbar/Index";
import DashboardHeader from "../Other/DashboardHeader";

function AuthLayout({ ...props }) {
  const isDesktop = () => document.body.clientWidth > 768;
  const [sidebarStatus, setSidebarStatus] = useState("");
  const token = JSON.parse(localStorage.getItem("accessToken"))
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768); // Adjust the threshold as needed

    const isTokenAvailable = token !== null && token !== undefined;
  useEffect(() => {
    window.addEventListener("resize", () => {
      setSidebarStatus(isDesktop());
    });


    return () => window.removeEventListener("resize", isDesktop);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768); // Adjust the threshold as needed
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="adminLayout" style={{height:"auto"}}>
      {/* Sidebar */}
      <Sidebar
        toggle={sidebarToggle}
        className={sidebarStatus ? "" : "mobile"}
      />

      {/* Main Wrapper */}
      <div className={isMobileView ? "mainWrapper bg-white" : "mainWrapper"}>
        {/* <DashboardHeader/> */}
        <Outlet context={[sidebarToggle]} />
      </div>

      {/* Bottom Navigation */}
      {isTokenAvailable && <BottomNavbar />}
    </div>
  );
}

export default AuthLayout;
